import React from "react";
import { ToastContainer, toast, ToastOptions, ToastContainerProps } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DEFAULTS: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

 export const useToast = (containerConfig?: ToastContainerProps) => {
  const success = (message: string, options?: ToastOptions) =>
    toast.success(message, { ...DEFAULTS, ...options });

  const error = (message: string, options?: ToastOptions) =>
    toast.error(message, { ...DEFAULTS, ...options });

  const warning = (message: string, options?: ToastOptions) =>
    toast.warning(message, { ...DEFAULTS, ...options });

  const ToastContainerConfigured = () => (
    <ToastContainer
      {...DEFAULTS}
      {...containerConfig}
    />
  );

  return {
    success,
    error,
    warning,
    ToastContainer: ToastContainerConfigured,
  };
};
